import { TemplateRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { IRouteMap } from "lib-core-shared";
import { Subject } from "rxjs";

export class TabItem implements IRouteMap {
    public loaded: boolean = false;
    public group!: FormGroup;
    public name!: string;
    public permission!: string;
    public fullRouteName!: string;
    public children?: IRouteMap[] | undefined;
    public label!: string;
    public groupSubject$?: Subject<FormGroup>;
    public active!: boolean;
    public visibility!: boolean;
    public template!: TemplateRef<any>
    constructor() {
        this.groupSubject$ = new Subject<FormGroup>();
        this.groupSubject$.subscribe(group => this.group = group);
    }
}